import React from 'react';
import './addUsers.css'
import axios from 'axios';

class AddUsers extends React.Component {
  constructor(props){
    super(props);
    this.state = {userName: '', userGender: '', userPhone: '', userAddress: '', userBloodGroup: '', userDonor: '', userDOB: '', userEmail: '', userPassword: ''};
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCheckBox = this.handleCheckBox.bind(this);
    this.handleShowHide = this.handleShowHide.bind(this);
  }

  handleChange(e){
    const state = this.state
    state[e.target.name] = e.target.value
    this.setState(state);
  }

  handleSubmit(e){
    e.preventDefault();

    const checkName = document.getElementById('userName').value
    const checkPhone = document.getElementById('userPhone').value
    const checkAddress = document.getElementById('userAddress').value
    const checkBloodGroup = document.getElementById('userBloodGroup').value
    const checkEmail = document.getElementById('userEmail').value
    const checkDOB = document.getElementById('userDOB').value
    const checkPassword = document.getElementById('userPassword').value

    const regexEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    const regexName = /^[a-z ,.'-]+$/i

    if(checkName == '' || checkPhone == '' || checkAddress == '' || checkBloodGroup == '' || checkEmail == '' || checkDOB == '' || checkPassword == ''){
      document.getElementById('errorName').style.display = 'block'
      document.getElementById('errorPhone').style.display = 'block'
      document.getElementById('errorAddress').style.display = 'block'
      document.getElementById('errorPhone').style.display = 'block'
      document.getElementById('errorBloodGroup').style.display = 'block'
      document.getElementById('errorEmail').style.display = 'block'
      document.getElementById('errorDOB').style.display = 'block'
      document.getElementById('errorPassword').style.display = 'block'
      return
    }
    else{
      document.getElementById('errorName').style.display = 'none'
      document.getElementById('errorPhone').style.display = 'none'
      document.getElementById('errorAddress').style.display = 'none'
      document.getElementById('errorPhone').style.display = 'none'
      document.getElementById('errorBloodGroup').style.display = 'none'
      document.getElementById('errorEmail').style.display = 'none'
      document.getElementById('errorDOB').style.display = 'none'
      document.getElementById('errorPassword').style.display = 'none'
    }

    if(document.getElementById('userGenderMale').checked || document.getElementById('userGenderFemale').checked){
      document.getElementById('errorGender').style.display = 'none'
    }
    else{
      document.getElementById('errorGender').style.display = 'block'
      return
    }

    if(!regexName.test(checkName)){
      document.getElementById('errorName').style.display = 'block'
      return
    }
    
    if(!regexEmail.test(checkEmail)){
      document.getElementById('errorEmail').style.display = 'block'
      return
    }

    if(checkPassword.length < 4 || checkPassword.length > 10){
      document.getElementById('errorPassword').style.display = 'block'
      return
    }
 
    this.register();
 
  }

  register(){
    let formData = new FormData();
    formData.append('userName', this.state.userName)
    formData.append('userGender', this.state.userGender)
    formData.append('userPhone', this.state.userPhone)
    formData.append('userAddress', this.state.userAddress)
    formData.append('userBloodGroup', this.state.userBloodGroup)
    formData.append('userDonor', this.state.userDonor)
    formData.append('userDOB', this.state.userDOB)
    formData.append('userEmail', this.state.userEmail)
    formData.append('userPassword', this.state.userPassword)
    
    axios({
        method: 'post',
        url: 'https://blood147.000webhostapp.com/admin_panel/addUsers.php',
        data: formData,
        config: { headers: {'Content-Type': 'multipart/form-data' }}
    })
    .then(function (response) {
        if(response.data == 'failed'){
          alert('Registration failed!!!\nMake sure your Contact and Email are correct.\nIf it still fails then try a different one.\nMaybe try again later.')
        }
        else{
          alert('Registration successful!!!')
          document.getElementById('userName').value = ''
          document.getElementById('userGenderMale').checked = false
          document.getElementById('userGenderFemale').checked = false
          document.getElementById('userPhone').value = ''
          document.getElementById('userAddress').value = ''
          document.getElementById('userDOB').value = ''
          document.getElementById('userBloodGroup').value = ''
          document.getElementById('userEmail').value = ''
          document.getElementById('userPassword').value = ''
          document.getElementById('userDonor').checked = false
        }  
    })
    .catch(function (response) {
        //handle error
        console.log(response)
    });
  }
  
  handleCheckBox(e){
    const check = document.getElementById('userDonor')

    if(check.checked == true){
      this.setState({ userDonor: 'true'})
    }
    else if(check.checked == false){
      this.setState({ userDonor: 'false'})
    }
  }

  handleShowHide(){
    const password = document.getElementById('userPassword')
    const toggle = document.getElementById('toggle')

    if (password.type === 'password') {
      password.setAttribute('type', 'text')
      toggle.classList.add('hide')
    }
    else{
      password.setAttribute('type', 'password')
      toggle.classList.remove('hide')
    }
  }

  render(){
    return (
      <div className="addUsers">
        <div className="addUsersContainer">
          <form className="addUsersForm">
            <div className="addUsersFormDiv">
              <div className="addUsersInputWrapper">
                <label htmlFor="userName" className='addUsersLabel'>Full Name:</label>
                <p id='errorName' className='errorMessage'>Please fill in alphabets!</p>
                <input id='userName' type="text" className="addUsersInput" placeholder="John Cena" name="userName" value={this.state.userName} onChange={this.handleChange}/> 
              </div>
              <div className="addUsersInputWrapper">
                <label className='addUsersLabel'>Gender:</label>
                <p id='errorGender' className='errorMessage'>Please select your gender!</p>
                <span id='userGender' className='addUsersSpanGender' onChange={this.handleChange}>
                  <input id='userGenderMale' type="radio" name="userGender" value='Male' />
                  <label htmlFor="male" style={{paddingRight: '10px'}}>Male</label>
                  <input id='userGenderFemale' type="radio" name="userGender" value='Female'/>
                  <label htmlFor="female">Female</label>
                </span>
              </div>
            </div>
  
            <div className="addUsersFormDiv">
              <div className="addUsersInputWrapper">
                <label htmlFor="userPhone" className='addUsersLabel'>Contact Number:</label>
                <p id='errorPhone' className='errorMessage'>Please fill your contact!</p>
                <input id='userPhone' type="number" className="addUsersInput" placeholder="9812345678" name="userPhone" value={this.state.userPhone} onChange={this.handleChange}/>
              </div>
              <div className="addUsersInputWrapper">
                <label htmlFor="userAddress" className='addUsersLabel'>Address:</label>
                <p id='errorAddress' className='errorMessage'>Please fill your address!</p>
                <input id='userAddress' type="text" className="addUsersInput" placeholder="Street, City, Country" name="userAddress" value={this.state.userAddress} onChange={this.handleChange}/>
              </div>
            </div>
  
            <div className="addUsersFormDiv">
              <div className="addUsersInputWrapper">
                <label htmlFor="userDOB" className='addUsersLabel'>Date of Birth:</label>
                <p id='errorDOB' className='errorMessage'>Please choose your Date Of Birth!</p>
                <input id='userDOB' type="date" className="addUsersInput" name="userDOB" value={this.state.userDOB} onChange={this.handleChange}/>
              </div>
              <div className="addUsersInputWrapper">
                <label htmlFor="userBloodGroup" className='addUsersLabel'>Blood Group:</label>
                <p id='errorBloodGroup' className='errorMessage'>Please select your Blood Group!</p>
                <select id='userBloodGroup' className='addUsersInput' name="userBloodGroup" value={this.state.userBloodGroup} onChange={this.handleChange}>
                  <option value="" disabled>Choose Blood Group...</option>
                  <option value="A+ve">A+ve</option>
                  <option value="A-ve">A-ve</option>
                  <option value="B+ve">B+ve</option>
                  <option value="B-ve">B-ve</option>
                  <option value="AB+ve">AB+ve</option>
                  <option value="AB-ve">AB-ve</option>
                  <option value="O+ve">O+ve</option>
                  <option value="O-ve">O-ve</option>
                </select>
              </div>
            </div>
  
            <div className="addUsersFormDiv">
              <div className="addUsersInputWrapper">
                <label htmlFor="userEmail" className='addUsersLabel'>Email:</label>
                <p id='errorEmail' className='errorMessage'>Please fill proper email!</p>
                <input id='userEmail' type="email" className="addUsersInput" placeholder="johncena10@gmail.com" name="userEmail" value={this.state.userEmail} onChange={this.handleChange}/>
              </div>
              <div className="addUsersInputWrapper">
                <label htmlFor="userPassword" className='addUsersLabel'>Password:</label>
                <p id='errorPassword' className='errorMessage'>Password must be 4 to 10 characters long!</p>
                <div className='addUsersInputPassword'>
                  <input id='userPassword' type="text" className='passwordBox' placeholder="4 to 10 characters" name="userPassword" value={this.state.userPassword} onChange={this.handleChange}/>
                  <div id='toggle' onClick={this.handleShowHide}/>
                </div>
              </div>
            </div>
  
            <div className="addUsersFormDiv">
              <div className="addUsersInputWrapper">
                <span className='addUsersSpan'>
                  <input type="checkbox" id='userDonor' name="userDonor" onChange={ this.handleCheckBox}/>
                  <label htmlFor="userDonor" style={{paddingLeft: '10px', fontSize: '16px'}}>I want to be a donor</label>
                </span>
              </div>
            </div>
  
            <div className="addUsersFormDiv">
              <div className="addUsersSubmitWrapper">
                <input type="submit" className='addUsersSubmit' onClick={this.handleSubmit} value="Register" />
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default AddUsers;